const rawLocale = typeof window === "undefined" ? "en" : (window.navigator.languages[0] ?? "en");
export const locale = rawLocale.toLowerCase().startsWith("fr") ? "fr" : "en";
export const translationLocale = locale;
